export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Створення віджета для"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Згенерувати"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оплата в"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сума платежу"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дії при успіху"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дії при неуспіху"])}
}